import { render, staticRenderFns } from "./NirvarMapped.vue?vue&type=template&id=7746f7ac&"
import script from "./NirvarMapped.vue?vue&type=script&lang=js&"
export * from "./NirvarMapped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports